<template>  
	<div id="sidebar" class="pt-0">
        <div class="cap_leftbar p_right">
          <div class="left_scrollbar">
            <div class="cap_logo text-center box-shadow d-flex align-items-center">
              <!-- <button type="button" id="sidebarCollapse" class="btn-btn mr-3">
                  <i data-feather="align-left"></i>
                </button> -->
              <div class="logoMian w-100">
              	<router-link title="Dashboard" :to="'/dashboard'" class="green"> <img src="../../../../static/fxView/images/logo.png" alt="Logo"></router-link>
              </div>
          </div>
           <div class="scrollbar">
              <nav class="side-navbar main-menu">
                <ul id="side-main-menu" class="side-menu list-unstyled">
                	<li>
						<router-link title="Dashboard" :to="'/dashboard'" :class="($route.path == '/dashboard')?'tabActive' :''">
							<span class="sprite1 bgIcon"><feather type="layout"></feather> </span> Dashboard
						</router-link>
					</li>
					<li>
						<router-link title="request-access" :to="'/request-access'" :class="($route.path == '/request-access')?'tabActive' :''">
							<span class="sprite1 bgIcon"><feather type="layout"></feather> </span> Request Access
						</router-link>
					</li>
					<li v-if="permissionModule('ADMIN_LIST','view')">
						<router-link title="users-list" :to="'/admin-list'" :class="($route.path == '/admin-list' || $route.path == '/admin-view')?'tabActive' :''">
							<span class="sprite2 bgIcon"><feather type="file-text"></feather></span> Manager List
						</router-link>
					</li> 				

					<li v-if="permissionModule('CLIENT_LIST','view')">
						<router-link title="users-list" :to="'/listing'" :class="($route.path == '/listing' || $route.path == '/view')?'tabActive' :'abc'">
							<span class="sprite2 bgIcon"><feather type="user-check"></feather></span> Client List
						</router-link>
					</li> 
					
					<li v-if="permissionModule('MASTER_LIST','view')">
						<router-link title="users-list" :to="'/master-listing'" :class="($route.path == '/master-listing' || $route.path == '/master-view')?'tabActive' :'abc'">
							<span class="sprite2 bgIcon"><feather type="user-check"></feather></span> Master List
						</router-link>
					</li>

					<li v-if="permissionModule('WITHDRAWAL_LIST','view')">
						<router-link title="withdrawal-list" :to="'/withdrawal-list'" :class="($route.path == '/withdrawal-list' || $route.path == '/withdrawal-view')?'tabActive' :'abc'">
							<span class="sprite3 bgIcon"><feather type="credit-card"></feather></span> Withdrawal List
						</router-link>
					</li> 
					
					<li v-if="permissionModule('DEPOSIT_LIST','view')">
						<router-link title="deposit-list" :to="'/deposit-list'" :class="($route.path == '/deposit-list' || $route.path == '/deposit-view')?'tabActive' :'abc'">
							<span class="sprite4 bgIcon"><feather type="layers"></feather></span> Deposit List
						</router-link>
					</li>

					<li>
						<router-link title="deposit-transaction" :to="'/deposit-transaction'" :class="($route.path == '/deposit-transaction')?'tabActive' :'abc'">
							<span class="sprite4 bgIcon"><feather type="layers"></feather></span> Deposit Transaction
						</router-link>
					</li>
					
					<li v-if="permissionModule('BONUS_LIST','view')">
						<router-link title="bonus-list" :to="'/bonus-list'" :class="($route.path == '/bonus-list' || $route.path == '/bonus-view')?'tabActive' :'abc'">
							<span class="sprite4 bgIcon"><feather type="database"></feather></span> Bonus List
						</router-link>
					</li>
					<li class="dropdown" :class="{ active: bonusBoosterOpen }">
						<a href="#" @click.prevent="bonusBoosterOpen = !bonusBoosterOpen" :class="($route.path == '/bonus-campaigns' || $route.path == '/bonus-campaign-view' || $route.path == '/bonus-redemptions' || $route.path == '/bonus-redemption-view') ? 'tabActive' : ''">
							<span class="sprite4 bgIcon"><feather type="gift"></feather></span> Bonus Booster
							<i class="rightarrow feather"><feather type="chevron-right"></feather></i>
						</a>
						<ul class="sub-menu list-unstyled">
							<li>
								<router-link :to="'/bonus-campaigns'" :class="($route.path == '/bonus-campaigns' || $route.path == '/bonus-campaign-view') ? 'tabActive' : ''">
									<span class="sprite4 bgIcon"><feather type="list"></feather></span> Manage Campaign
								</router-link>
							</li>
							<li>
								<router-link :to="'/bonus-redemptions'" :class="($route.path == '/bonus-redemptions' || $route.path == '/bonus-redemption-view') ? 'tabActive' : ''">
									<span class="sprite4 bgIcon"><feather type="refresh-cw"></feather></span> Redemption Request
								</router-link>
							</li>
						</ul>
					</li>
					<li v-if="permissionModule('COMMISSION_LIST','view')">
						<router-link title="commission-list" :to="'/commission-list'" :class="($route.path == '/commission-list' || $route.path == '/commission-view')?'tabActive' :'abc'">
							<span class="sprite4 bgIcon"><feather type="database"></feather></span> Commission List
						</router-link>
					</li>

					<li v-if="permissionModule('TRADING_LIST','view')">
						<router-link title="trading-list" :to="'/trading-list'" :class="($route.path == '/trading-list' || $route.path == '/trading-view')?'tabActive' :'abc'">
							<span class="sprite5 bgIcon"><feather type="trending-up"></feather></span> Trading List
						</router-link>
					</li>

					<li v-if="permissionModule('TRADING_LIST','view')">
						<router-link title="copytrading-list" :to="'/copytrading-list'" :class="($route.path == '/copytrading-list' || $route.path == '/copytrading-view')?'tabActive' :'abc'">
							<span class="sprite5 bgIcon"><feather type="trending-up"></feather></span> CopyTrading List
						</router-link>
					</li>

					<li v-if="permissionModule('TICKET_LIST','view')">
						<router-link title="ticket-list" :to="'/ticket-list'" :class="($route.path == '/ticket-list' || $route.path == '/ticket-view')?'tabActive' : 'abc'">
							<span class="sprite4 bgIcon"><feather type="tag"></feather></span> Ticket List
						</router-link>
					</li>
					<li v-if="user && user.id && (user.id == '4' || user.id == '5')">
						<router-link title="ticket-list" :to="'/contact-us'" :class="$route.path == '/contact-us' ? 'tabActive' : ''">
							<span class="sprite4 bgIcon"><feather type="tag"></feather></span> Update Contact Details
						</router-link>
					</li>
					<!-- <li>
						<router-link title="notification-list" :to="'/notification-list'" :class="($route.path == '/notification-list' || $route.path == '/notification-view')?'tabActive' :'abc'">
							<span class="sprite4 bgIcon"><feather type="layers"></feather></span> Notification List
						</router-link>
					</li> -->

                </ul>
              </nav>
           </div>
          </div>
      </div>
    </div>
</template>
<script> 
    import { LayoutIcon,UserIcon,UsersIcon,LogOutIcon } from 'vue-feather-icons'
	import { fxViewMixins } from '@/plugins/fxView'
	// import { fxViewMixins } from '@/store'

	import * as types from '@/types'
    export default{
        name: 'fxViewApp',
		mixins: [fxViewMixins], 		
        data(){
            return {
            	user:{},
            	bonusBoosterOpen: false
            }
        },
		created(){
			this.user = this.get_user
			this.bonusBoosterOpen = this.$route.path.startsWith('/bonus-campaign') || this.$route.path === '/bonus-campaigns' || this.$route.path.startsWith('/bonus-redemption')
		},
		watch: {
			$route(to) {
				if (to.path.startsWith('/bonus-campaign') || to.path === '/bonus-campaigns' || to.path.startsWith('/bonus-redemption')) {
					this.bonusBoosterOpen = true
				} else {
					this.bonusBoosterOpen = false
				}
			}
		},
        components: {
           LayoutIcon,
           UsersIcon,
           UserIcon,LogOutIcon
        },
		
		methods:{ },
		mounted(){
		  $('.dropdown').click( function() {
			$(this).addClass('active').siblings().removeClass('active');
		  });
		}
    }
</script>




// WEBPACK FOOTER //
// src/components/fxView/shared/left_navigation.vue